import {
    FETCH_ALL_CONSOLIDATED_REQUEST,
    FETCH_ALL_CONSOLIDATED_SUCCESS,
    FETCH_ALL_CONSOLIDATED_FAILED,
    DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_REQUEST,
    DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_SUCCESS,
    DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_FAILED
} from './mutation-type'

const mutations = {
    [FETCH_ALL_CONSOLIDATED_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_ALL_CONSOLIDATED_SUCCESS]: (state, { status, data }) => {
        state.status = status
        state.cumulativeCost = (data && data.cumulativeCost) || { currentMonthCost: 0, estimatedCost: 0, prevMonthCost: 0 }
        state.currentTrends = (data && data.currentTrends) || []
        state.pastTrends = (data && data.pastTrends) || []
        state.finalData = (data && data.finalData) || { estimated: [], past: [] }
        state.months = (data && data.months) || []
        state.regions = (data && data.regions) || []
        state.products = (data && data.products) || []
    },
    [FETCH_ALL_CONSOLIDATED_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_REQUEST]: state => {
        // state.status = 'loading'
        state.downloadLoading = true
    },
    [DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_SUCCESS]: state => {
        // state.status = 'success'
        state.downloadLoading = false
    },
    [DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_FAILED]: (state, error) => {
        // state.status = 'error'
        state.downloadLoading = false
    }
}

export default mutations
